import DOWNLOAD_PLM_MATERIAL from './downloadPlmMaterial.graphql'
import PLM_MATERIALS         from './plmMaterials.graphql'

export {DOWNLOAD_PLM_MATERIAL, PLM_MATERIALS}
export * from './enhancers'



// WEBPACK FOOTER //
// ./src/modules/common/graphql/plmMaterial/index.ts